import { Component } from "@angular/core";

@Component({
  selector: "app-icon-24-hours",
  imports: [],
  templateUrl: "./icon-24-hours.component.html",
  styleUrl: "./icon-24-hours.component.scss",
})
export class Icon24HoursComponent {}
